import { PaymentMethodAvailabilityResult } from '@mews-commander/data-access';
import { ProcessPaymentType } from './ProcessPaymentType';
import { CHARGE_GUEST_PROCESS_PAYMENT_TYPES, EXTERNAL_PROCESS_PAYMENT_TYPES } from './const';

const mapPaymentTypeToDataTestId: Record<ProcessPaymentType, string> = {
    [ProcessPaymentType.CashPayment]: 'record_cash_payment',
    [ProcessPaymentType.ExternalCardPayment]: 'record_ext_card_payment',
    [ProcessPaymentType.ExternalPayment]: 'record_ext_payment',
    [ProcessPaymentType.RecordCard]: 'record_card',
    [ProcessPaymentType.GatewayPayment]: 'create_card_payment',
    [ProcessPaymentType.PaymentRequest]: 'create_payment_request',
    [ProcessPaymentType.MewsTerminalPayment]: 'create_terminal_payment',
    [ProcessPaymentType.TokenizeCard]: 'create_tokenized_card',
    [ProcessPaymentType.GatewayCardPreauth]: 'create_card_preauthorization',
    [ProcessPaymentType.ExternalCardPreauth]: 'record_ext_preauthorization',
    [ProcessPaymentType.MewsTerminalPreauth]: 'create_terminal_preauthorization',
};

export const getPaymentTypeDataTestId = (paymentType?: ProcessPaymentType) =>
    paymentType ? mapPaymentTypeToDataTestId[paymentType] : undefined;

export const getPaymentTypesEnabledSetting = (
    data: PaymentMethodAvailabilityResult | undefined
): Record<ProcessPaymentType, boolean | undefined> => {
    const { gatewayCard, mewsTerminal, cash, paymentTerminal, external, paymentRequest } = data ?? {};

    return {
        [ProcessPaymentType.GatewayPayment]: gatewayCard,
        [ProcessPaymentType.MewsTerminalPayment]: mewsTerminal,
        [ProcessPaymentType.PaymentRequest]: paymentRequest,
        [ProcessPaymentType.TokenizeCard]: gatewayCard,
        [ProcessPaymentType.CashPayment]: cash,
        [ProcessPaymentType.ExternalCardPayment]: paymentTerminal,
        [ProcessPaymentType.ExternalPayment]: external,
        [ProcessPaymentType.RecordCard]: paymentTerminal,
        [ProcessPaymentType.GatewayCardPreauth]: gatewayCard,
        [ProcessPaymentType.ExternalCardPreauth]: paymentTerminal,
        [ProcessPaymentType.MewsTerminalPreauth]: mewsTerminal,
    };
};

export const getFilteredProcessPaymentDialogTypes = (paymentTypes: ProcessPaymentType[]) => {
    const chargeGuestPaymentTypes = paymentTypes.filter((type) => CHARGE_GUEST_PROCESS_PAYMENT_TYPES.includes(type));
    const externalPaymentTypes = paymentTypes.filter((type) => EXTERNAL_PROCESS_PAYMENT_TYPES.includes(type));

    return {
        chargeGuestPaymentTypes,
        externalPaymentTypes,
    };
};
